var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactPerson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_908_499",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#196CCA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_908_499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 7.00016C6.35831 7.00016 5.80901 6.77169 5.35206 6.31475C4.89512 5.8578 4.66665 5.3085 4.66665 4.66683C4.66665 4.02516 4.89512 3.47586 5.35206 3.01891C5.80901 2.56197 6.35831 2.3335 6.99998 2.3335C7.64165 2.3335 8.19095 2.56197 8.6479 3.01891C9.10484 3.47586 9.33331 4.02516 9.33331 4.66683C9.33331 5.3085 9.10484 5.8578 8.6479 6.31475C8.19095 6.77169 7.64165 7.00016 6.99998 7.00016ZM2.33331 11.6668V10.0335C2.33331 9.70294 2.41838 9.39912 2.58852 9.12204C2.75866 8.84495 2.9847 8.6335 3.26665 8.48766C3.86942 8.18627 4.48192 7.96023 5.10415 7.80954C5.72637 7.65884 6.35831 7.5835 6.99998 7.5835C7.64165 7.5835 8.27359 7.65884 8.89581 7.80954C9.51803 7.96023 10.1305 8.18627 10.7333 8.48766C11.0153 8.6335 11.2413 8.84495 11.4114 9.12204C11.5816 9.39912 11.6666 9.70294 11.6666 10.0335V11.6668H2.33331Z",
    fill: "#196CCA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPerson);
export default __webpack_public_path__ + "static/media/contact-person.141e354eb4775237a02afb430733b05e.svg";
export { ForwardRef as ReactComponent };